import { events } from '../../events';
import { component } from '../../framework/component.decorator';
import { delay } from '../../utils/delay.fn';
import { StartRecordingTriggerComponent } from '../start-recording-trigger/start-recording-trigger.component';
import styles from '../start-recording-trigger/start-recording-trigger.component.scss';

@component({
  selector: 'app-delayed-start-recording-trigger',
  styles,
})
export class DelayedStartRecordingTriggerComponent extends StartRecordingTriggerComponent {
  constructor() {
    super('hourglass-split', 'Click to start delayed recording');
  }

  protected async onClick() {
    events.emit('start-delayed-recording');
    const icon$ = this.getIconClone();

    await this.setTextAndWait('5');
    await this.setTextAndWait('4');
    await this.setTextAndWait('3');
    await this.setTextAndWait('2');
    await this.setTextAndWait('1');

    super.onClick();
    this.reset(icon$);
  }

  private async setTextAndWait(text: string) {
    this.setText(text);
    await delay(1000);
  }

  private async setText(text: string | null) {
    this.doOnFirstChild((el) => (el.textContent = text));
  }

  private reset(icon: Node | undefined) {
    this.setText(null);

    if (icon !== undefined) {
      this.getFirstChild()?.appendChild(icon);
    }
  }

  private getIconClone() {
    return this._root.querySelector<HTMLElement>('i.bi')?.cloneNode(true);
  }
}
